import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { FeatureFlagService } from '../../shared/misc-services/feature-flag.service';

@Component({
  selector: 'h3-sampling-workspace-header',
  templateUrl: './sampling-workspace-header.component.html',
  styleUrls: ['./sampling-workspace-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SamplingWorkspaceHeaderComponent {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  enableNewSamplingNav = inject(FeatureFlagService).hasFlag('new-sampling-nav');

  showInputSummary$ = this.buildShowInputSummary$();

  private buildShowInputSummary$() {
    return this.taskWorkspaceStore('project').$.pipe(
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      map((project) => project && !project.sampling_layout_step_id),
    );
  }
}
